const AyudaPreguntaIcon = ({ color }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.21332 11.0671V10.9222C8.21616 10.4251 8.2602 10.0288 8.34542 9.73331C8.43349 9.43786 8.56133 9.19922 8.72895 9.0174C8.89656 8.83558 9.09826 8.67081 9.33406 8.52308C9.5102 8.40945 9.66787 8.29155 9.80707 8.16939C9.94628 8.04723 10.0571 7.91229 10.1395 7.76456C10.2218 7.61399 10.263 7.44638 10.263 7.26172C10.263 7.0657 10.2162 6.89382 10.1224 6.74609C10.0287 6.59837 9.90224 6.48473 9.74315 6.40518C9.5869 6.32564 9.4136 6.28587 9.22326 6.28587C9.0386 6.28587 8.86389 6.32706 8.69912 6.40945C8.53434 6.48899 8.3994 6.60831 8.29429 6.7674C8.18917 6.92365 8.13235 7.11825 8.12383 7.35121H6.3852C6.3994 6.78303 6.53576 6.31428 6.79429 5.94496C7.05281 5.5728 7.39514 5.29581 7.82128 5.11399C8.24741 4.92933 8.71758 4.837 9.23179 4.837C9.79713 4.837 10.2971 4.93075 10.7318 5.11825C11.1664 5.30291 11.5074 5.57138 11.7545 5.92365C12.0017 6.27592 12.1253 6.70064 12.1253 7.1978C12.1253 7.53018 12.0699 7.82564 11.9591 8.08416C11.8511 8.33984 11.6991 8.56712 11.5031 8.76598C11.3071 8.962 11.0755 9.13956 10.8085 9.29865C10.5841 9.43217 10.3994 9.57138 10.2545 9.71626C10.1125 9.86115 10.0059 10.0288 9.93491 10.2191C9.86673 10.4094 9.83122 10.6438 9.82838 10.9222V11.0671H8.21332ZM9.05707 13.7944C8.77298 13.7944 8.53008 13.695 8.32838 13.4961C8.12951 13.2944 8.0315 13.0529 8.03434 12.7717C8.0315 12.4933 8.12951 12.2546 8.32838 12.0558C8.53008 11.8569 8.77298 11.7575 9.05707 11.7575C9.32696 11.7575 9.56417 11.8569 9.76872 12.0558C9.97326 12.2546 10.077 12.4933 10.0798 12.7717C10.077 12.9592 10.0272 13.131 9.93065 13.2873C9.8369 13.4407 9.71332 13.5643 9.55991 13.658C9.4065 13.7489 9.23889 13.7944 9.05707 13.7944Z"
        fill={color}
      />
      <circle
        cx="9.30238"
        cy="8.9391"
        r="7.77113"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default AyudaPreguntaIcon;
